import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'My biggest problem was practice planning. Basketball Ready gave me an entire season of structure. I spend less time planning and more time coaching.',
  author: 'Michael T.',
  role: 'Youth Basketball Coach'
}, {
  quote: 'The Practice Vault and Team Culture Playbook completely changed how I organize my program. This system is worth far more than the price.',
  author: 'James R.',
  role: 'Academy Coach'
}];
export function Testimonials() {
  return <section className="py-20 bg-navy-900 relative" data-id="element-229">
      <div className="container mx-auto px-4" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-232">
            WHAT OTHER COACHES ARE SAYING
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-233">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-950 border border-navy-800 rounded-2xl p-8 relative" data-id="element-234">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-navy-800" data-id="element-235" />

              <div className="flex gap-1 mb-6" data-id="element-236">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-237" />)}
              </div>

              <p className="text-xl text-gray-300 italic mb-8 relative z-10" data-id="element-238">
                "{testimonial.quote}"
              </p>

              <div data-id="element-239">
                <div className="font-oswald text-xl text-white uppercase tracking-wide" data-id="element-240">
                  {testimonial.author}
                </div>
                <div className="text-gold-500 text-sm font-medium" data-id="element-241">
                  {testimonial.role}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}